import { DashboardWidget } from "../types";

export const FULFILLED = "FULFILLED";
export const PENDING = "PENDING";
export const REJECTED = "REJECTED";

export const OS_EMP_ACCOUNT_ID1 = 50937;
